import { Grid } from '@material-ui/core';
import React from 'react';
import BaseButton from 'src/common/components/base-button';
import { styles } from './actions-container-styles';

const ActionsContainer: React.FC<IActionsContainerProps> = ({
  close,
  submit,
  canSubmit,
  submitText,
}: IActionsContainerProps): JSX.Element => {
  const classes = styles();

  return (
    <Grid container alignItems='flex-end'>
      <Grid item>
        <BaseButton
          buttonType='white'
          className={classes.cancelButton}
          onClick={close}
          data-testid='input-data-required-cancel-button'
        >
          Cancel
        </BaseButton>
      </Grid>
      <Grid item>
        <BaseButton
          className={classes.approveButton}
          onClick={submit}
          data-testid='input-data-required-approve-button'
          disabled={!canSubmit}
        >
          {submitText || 'Approve'}
        </BaseButton>
      </Grid>
    </Grid>
  );
};

export interface IActionsContainerProps {
  close: () => void;
  submit: () => void;
  submitText?: string;
  canSubmit: boolean;
}

export default ActionsContainer;
